import * as Yup from 'yup';

import {
  globalMessages,
  isEmail,
  isValidPhoneNumber,
} from '@savgroup-front-common/core/helpers';

const CustomerPersonalInformationSchema = ({
  isBusiness,
}: {
  isBusiness: boolean;
}) => {
  return Yup.object().shape({
    firstName: Yup.string().when('$isRequired', {
      is: !isBusiness,
      then: (schema) => schema.required(globalMessages.form.required),
      otherwise: (schema) => schema,
    }),
    lastName: Yup.string().when('$isRequired', {
      is: !isBusiness,
      then: (schema) => schema.required(globalMessages.form.required),
      otherwise: (schema) => schema,
    }),
    companyName: Yup.string(),
    email: Yup.string()
      .required(globalMessages.form.required)
      .test('is-email', globalMessages.form.invalidEmail, (value) => {
        return isEmail(value);
      }),
    phoneNumber: Yup.string()
      .required(globalMessages.form.required)
      .test(
        'validPhoneNumber',
        globalMessages.form.invalidPhoneNumber,
        (value, context) => {
          const { phoneCountryCode } = context.parent;

          if (!phoneCountryCode) {
            return false;
          }

          return value ? isValidPhoneNumber(value, phoneCountryCode) : true;
        },
      ),
  });
};

export default CustomerPersonalInformationSchema;
